import React from "react";
import { Route, Switch } from "react-router-dom";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";
import Home from "./containers/Home";
import Login from "./containers/Login";
import ResetPassword from "./containers/ResetPassword";
import RequestLoginId from "./containers/RequestLoginId";
import Signup from "./containers/Signup";
import Members from "./containers/Members";
import ViewMembers from "./containers/ViewMembers";
import Menu from "./containers/Menu";
import Top from "./containers/Top";
import AdminHome from "./containers/AdminHome";
import AdminMemberships from "./containers/AdminMemberships";
import AdminReports from "./containers/AdminReports";
import AdminAnnualFees from "./containers/AdminAnnualFees";
import AdminNewMail from "./containers/AdminNewMail";
import SetupPassword from "./containers/SetupPassword";
import MyPage from "./containers/MyPage";
import AdminMailHistories from "./containers/AdminMailHistories";
import AdminDownloads from "./containers/AdminDownloads";
import NotFound from "./containers/NotFound";

export default function Routes() {
  return (
    <Switch>
      <UnauthenticatedRoute exact path="/">
        <Menu />
      </UnauthenticatedRoute>
      <UnauthenticatedRoute exact path="/a-menu">
        <Top />
      </UnauthenticatedRoute>
      <AuthenticatedRoute exact path="/home">
        <Home />
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path="/mypage">
        <MyPage />
      </AuthenticatedRoute>
      <UnauthenticatedRoute exact path="/login">
        <Login />
      </UnauthenticatedRoute>
      <UnauthenticatedRoute exact path="/login/reset">
        <ResetPassword />
      </UnauthenticatedRoute>
      <UnauthenticatedRoute exact path="/login/request">
        <RequestLoginId />
      </UnauthenticatedRoute>
      <UnauthenticatedRoute exact path="/signup">
        <Signup />
      </UnauthenticatedRoute>
      <UnauthenticatedRoute exact path="/spw">
        <SetupPassword />
      </UnauthenticatedRoute>
      <AuthenticatedRoute exact path="/a-signup">
        <Signup />
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path="/admin">
        <AdminHome />
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path="/admin/memberships">
        <AdminMemberships />
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path="/editMembers/:id">
        <Members />
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path="/members/:id">
        <ViewMembers />
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path="/admin/reports">
        <AdminReports />
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path="/admin/annualReports">
        <AdminAnnualFees />
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path="/admin/newMail">
        <AdminNewMail />
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path="/admin/mailHistories">
        <AdminMailHistories />
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path="/admin/downloads">
        <AdminDownloads />
      </AuthenticatedRoute>
      {/* Finally, catch all unmatched routes */}
      <AuthenticatedRoute>
        <NotFound />
      </AuthenticatedRoute>
    </Switch>
  );
}
